// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"signinas_loaderContainer__F5OgA"};